/*
 * file: AllRoutes.jsx
 * 상세: 라우터 경로 설정
 */

// 인증되지 않은 사용자 
import Login from "../pages/Authentication/Login";
import Signup from "../pages/Authentication/Signup";

// 인증된 사용자
import Main from "pages/AllTournament/Index"
import TournamentRequest from "pages/MyPage/TournamentRequest"
import Detail from "pages/TournamentRelated/Detail"
import RealRanking from "pages/RealRanking/Index";
import Ranking from "pages/Ranking/Index";
import MyTournament from "pages/MyTournament/Index";
import MyPage from "pages/MyPage/Index"
import Note from "pages/MyPage/Note"
import List from "pages/MyPage/Inquery/List"
import Add from "pages/MyPage/Inquery/Add"

const authRoutes = [
  { path: "/", component: <Main /> },
  { path: "/login", component: <Login /> },
  { path: "/myTournament", component: <MyTournament /> },
  { path: "/myPage", component: <MyPage /> },
  { path: "/ranking", component: <Ranking /> },
  { path: "/realRanking", component: <RealRanking /> },
  { path: "/tournamentDetail/:tournament_idx", component: <Detail /> },
  { path: "/myPage/message", component: <Note /> },
  { path: "/myPage/inquery", component: <List /> },
  { path: "/myPage/inqueryAdd", component: <Add /> },
  { path: "/myPage/tournamentRequest", component: <TournamentRequest /> }
];

const unAuthRoutes = [
  { path: "/", component: <Login /> },
  { path: "/signup", component: <Signup /> },
];

export { authRoutes, unAuthRoutes };
